import type { GroupMonthlyMemo } from "@/components/feature/roster_create/utils/groupMonthlyMemo";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import { useQuery } from "@tanstack/react-query";

export type GroupMonthlyMemoResponse = Readonly<{
  year: number;
  month: number;
  group_id: string;
  count: number;
  memos: GroupMonthlyMemo[];
}>;

export function useGroupMonthlyMemoQuery(
  year: number | undefined,
  month: number | undefined,
  groupId: string | null | undefined,
  enabled: boolean
) {
  const normalizedGroupId = groupId?.trim() || undefined;

  return useQuery<GroupMonthlyMemoResponse>({
    queryKey: QUERY_KEYS.preferences.monthlyMemoGroup(
      year ?? 0,
      month ?? 0,
      normalizedGroupId
    ),
    queryFn: async () => {
      if (!year || !month || !normalizedGroupId) {
        throw new Error("월별 메모 조회에 필요한 값이 없습니다.");
      }

      return await httpClient.get<GroupMonthlyMemoResponse>(
        "/preferences/monthly-memo/group",
        { params: { year, month, group_id: normalizedGroupId } }
      );
    },
    enabled: Boolean(year && month && normalizedGroupId && enabled),
    staleTime: 5 * 60 * 1000,
  });
}
